import { required } from 'vuelidate/lib/validators'

/**
 * Model "class" for Habit - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        habit: {
            label: 'LABEL_HABIT_DESCRIPTION',
            type: 'textarea',
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
        categories: {
            label: 'LABEL_HABIT_CATEGORIES',
            type: 'checks',
            options: {
                'food': 'FIELD_HABIT_CATEGORY_FOOD',
                'movement': 'FIELD_HABIT_CATEGORY_MOVEMENT',
                'emotions': 'FIELD_HABIT_CATEGORY_EMOTIONS',
                'sleep': 'FIELD_HABIT_CATEGORY_SLEEP',
                'worklife': 'FIELD_HABIT_CATEGORY_WORKLIFE'
            },
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
    }
}
